import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mesh-view-container" }
const _hoisted_2 = {
  key: 0,
  class: "no-gps-section mt-2 pa-2"
}
const _hoisted_3 = { class: "d-flex align-center mb-2 ga-2" }
const _hoisted_4 = { class: "no-gps-scroll-container d-flex ga-2 pb-1" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "operability-bar-wrapper mb-1" }
const _hoisted_7 = { class: "operability-stacked-bar" }
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "d-flex justify-space-between align-center ga-2" }
const _hoisted_13 = { class: "d-flex justify-space-between align-center mt-1 style-details" }
const _hoisted_14 = { class: "device-model text-truncate" }
const _hoisted_15 = { class: "ip-text" }
const _hoisted_16 = { class: "d-flex justify-end align-center mt-1" }
const _hoisted_17 = { class: "date-text" }

import { ref, computed, onMounted, onUnmounted, watch, nextTick } from "vue";
import maplibregl, { LngLatLike, Map, Popup, Marker } from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";

import CONSTMAPS from "@/constants/maps";
// import { LATENCY } from "@/interfaces/SmartLink/Topology";
import { getDeviceModel } from "@/utils/SmartLink/device";


export default /*@__PURE__*/_defineComponent({
  __name: 'MeshTopology',
  props: {
    items: {},
    getLatencyColor: { type: Function },
    getOperabilityPercentages: { type: Function },
    formatShortDate: { type: Function }
  },
  emits: ["select-device"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const wrapperRef = ref<HTMLElement | null>(null);
const isFullscreen = ref(false);
let mapInstance: Map | null = null;
let activePopup: Popup | null = null;
let currentMarkers: Marker[] = [];

const centerMap = ref<LngLatLike>([
    CONSTMAPS.longitud.value,
    CONSTMAPS.latitud.value,
]);

// Deduplicar la lista total de items
const uniqueItems = computed(() => {
    return props.items.filter(
        (item, index, self) => index === self.findIndex((t) => t.ip === item.ip)
    );
});

// Separación A: Equipos con coordenadas válidas para dibujar en el mapa
const equiposConGps = computed(() => {
    return uniqueItems.value.filter(
        (e) =>
            e.latitud !== undefined &&
            e.longitud !== undefined &&
            Number(e.latitud) !== -1 &&
            Number(e.longitud) !== -1 &&
            Number(e.latitud) !== 0 &&
            Number(e.longitud) !== 0
    );
});

// Separación B: Equipos sin coordenadas válidas (-1, 0 o indefinidos)
const equiposSinGps = computed(() => {
    return uniqueItems.value.filter(
        (e) =>
            e.latitud === undefined ||
            e.longitud === undefined ||
            Number(e.latitud) === -1 ||
            Number(e.longitud) === -1 ||
            Number(e.latitud) === 0 ||
            Number(e.longitud) === 0
    );
});

const clearMarkers = () => {
    currentMarkers.forEach((marker) => marker.remove());
    currentMarkers = [];
};

const renderMapMarkers = () => {
    if (!mapInstance) return;

    clearMarkers();

    equiposConGps.value.forEach((equipo) => {
        const latColor = props.getLatencyColor(equipo.latencia);
        const modelText = getDeviceModel(equipo.anotacion);
        const dateText = props.formatShortDate(equipo.fecha);
        const op = props.getOperabilityPercentages(equipo.ip);
        const latDisplay = equipo.latencia < 0 ? "OFF" : `${equipo.latencia}ms`;

        const el = document.createElement("div");
        el.className = "custom-map-marker";

        el.innerHTML = `
            <div class="marker-op-box">
                <div class="marker-op-bar">
                    <div class="op-seg" style="width: ${op.ok}%; background-color: #00E676;"></div>
                    <div class="op-seg" style="width: ${op.alert}%; background-color: #FFEA00;"></div>
                    <div class="op-seg" style="width: ${op.alarm}%; background-color: #FF3D00;"></div>
                    <div class="op-seg" style="width: ${op.down}%; background-color: #9E9E9E;"></div>
                </div>
            </div>
            <div class="marker-text-content">
                <div class="marker-name" style="color: ${latColor};">${equipo.name}</div>
                <div class="marker-model-lat" style="color: ${latColor};">
                    ${modelText} (${latDisplay})
                </div>
            </div>
        `;

        el.addEventListener("click", (e) => {
            e.stopPropagation();
            emit("select-device", equipo);
        });

        el.addEventListener("mouseenter", () => {
            if (!mapInstance) return;

            const htmlContent = `
                <div style="font-family: sans-serif; padding: 4px; font-size: 0.78rem; color: #0F172A;">
                    <b style="font-size: 0.85rem; color: #0F172A;">${equipo.name}</b><br/>
                    <span style="color: #0284C7;"><b>Modelo:</b> ${modelText}</span><br/>
                    <span><b>IP:</b> ${equipo.ip}</span><br/>
                    <span><b>Latencia:</b> ${latDisplay}</span><br/>
                    <span><b>Última act.:</b> ${dateText}</span>
                    <hr style="border-top: 1px solid #CBD5E1; margin: 4px 0;" />
                    <b>Operatividad:</b><br/>
                    <span style="color: #16A34A;">● Excelente estado: ${op.ok.toFixed(1)}%</span><br/>
                    <span style="color: #CA8A04;">● Alerta leve: ${op.alert.toFixed(1)}%</span><br/>
                    <span style="color: #DC2626;">● Alarma crítica: ${op.alarm.toFixed(1)}%</span><br/>
                    <span style="color: #64748B;">● Fuera de servicio: ${op.down.toFixed(1)}%</span>
                </div>
            `;

            if (activePopup) activePopup.remove();
            activePopup = new maplibregl.Popup({ closeButton: false, offset: 15 })
                .setLngLat([Number(equipo.longitud), Number(equipo.latitud)])
                .setHTML(htmlContent)
                .addTo(mapInstance);
        });

        el.addEventListener("mouseleave", () => {
            if (activePopup) {
                activePopup.remove();
                activePopup = null;
            }
        });

        const marker = new maplibregl.Marker({ element: el })
            .setLngLat([Number(equipo.longitud), Number(equipo.latitud)])
            .addTo(mapInstance);

        currentMarkers.push(marker);
    });
};

watch(
    () => props.items,
    () => {
        renderMapMarkers();
    },
    { deep: true }
);

function inicializarMapa() {
    mapInstance = new maplibregl.Map({
        container: "mapMeshContainer",
        center: centerMap.value,
        zoom: 14,
        pitch: 35,
        bearing: 20,
        style: "https://api.maptiler.com/maps/satellite/style.json?key=6JWVt6LFaY22nquimZpF",
    });

    mapInstance.addControl(new maplibregl.NavigationControl(), "top-right");

    mapInstance.on("load", () => {
        setTimeout(() => {
            if (mapInstance) {
                mapInstance.resize();
                renderMapMarkers();
            }
        }, 300);
    });
}

function toggleFullscreen() {
    if (!wrapperRef.value) return;
    if (!document.fullscreenElement) {
        wrapperRef.value.requestFullscreen().then(() => {
            isFullscreen.value = true;
            nextTick(() => mapInstance?.resize());
        });
    } else {
        document.exitFullscreen().then(() => {
            isFullscreen.value = false;
            nextTick(() => mapInstance?.resize());
        });
    }
}

onMounted(() => {
    nextTick(() => {
        inicializarMapa();
    });
});

onUnmounted(() => {
    clearMarkers();
    if (mapInstance) mapInstance.remove();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "wrapperRef",
      ref: wrapperRef,
      class: "topology-wrapper"
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("div", {
        id: "mapMeshContainer",
        class: "mapMeshContainer"
      }, null, -1)),
      _createVNode(_component_v_btn, {
        icon: "",
        size: "small",
        color: "slate-800",
        class: "fullscreen-btn",
        onClick: toggleFullscreen
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(isFullscreen.value ? 'mdi-fullscreen-exit' : 'mdi-fullscreen'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 512),
    (equiposSinGps.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              size: "x-small",
              color: "warning"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-map-marker-off", -1)
              ]))]),
              _: 1
            }),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "no-gps-title font-weight-bold" }, " Equipos sin ubicación GPS ", -1)),
            _createVNode(_component_v_chip, {
              size: "x-small",
              color: "grey-darken-2",
              variant: "flat",
              class: "px-1",
              style: {"height":"16px","font-size":"0.65rem"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(equiposSinGps.value.length), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(equiposSinGps.value, (equipo) => {
              return (_openBlock(), _createElementBlock("div", {
                key: equipo.ip,
                class: "no-gps-card pa-1 px-2",
                onClick: ($event: any) => (_ctx.$emit('select-device', equipo))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", {
                      class: "bar-segment",
                      style: _normalizeStyle([{"background-color":"#00E676"}, { width: __props.getOperabilityPercentages(equipo.ip).ok + '%' }]),
                      title: `Excelente estado: ${__props.getOperabilityPercentages(equipo.ip).ok.toFixed(1)}%`
                    }, null, 12, _hoisted_8),
                    _createElementVNode("div", {
                      class: "bar-segment",
                      style: _normalizeStyle([{"background-color":"#FFEA00"}, { width: __props.getOperabilityPercentages(equipo.ip).alert + '%' }]),
                      title: `Alerta leve: ${__props.getOperabilityPercentages(equipo.ip).alert.toFixed(1)}%`
                    }, null, 12, _hoisted_9),
                    _createElementVNode("div", {
                      class: "bar-segment",
                      style: _normalizeStyle([{"background-color":"#FF3D00"}, { width: __props.getOperabilityPercentages(equipo.ip).alarm + '%' }]),
                      title: `Alarma crítica: ${__props.getOperabilityPercentages(equipo.ip).alarm.toFixed(1)}%`
                    }, null, 12, _hoisted_10),
                    _createElementVNode("div", {
                      class: "bar-segment",
                      style: _normalizeStyle([{"background-color":"#9E9E9E"}, { width: __props.getOperabilityPercentages(equipo.ip).down + '%' }]),
                      title: `Fuera de servicio: ${__props.getOperabilityPercentages(equipo.ip).down.toFixed(1)}%`
                    }, null, 12, _hoisted_11)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", {
                    class: "device-name font-weight-bold text-truncate",
                    style: _normalizeStyle({ color: __props.getLatencyColor(equipo.latencia) })
                  }, _toDisplayString(equipo.name), 5),
                  _createElementVNode("span", {
                    class: "latency-badge font-weight-bold",
                    style: _normalizeStyle({ color: __props.getLatencyColor(equipo.latencia), borderColor: __props.getLatencyColor(equipo.latencia) })
                  }, _toDisplayString(equipo.latencia < 0 ? 'OFF' : `${equipo.latencia}ms`), 5)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(getDeviceModel)(equipo.anotacion)), 1),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(equipo.ip), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, "Upd: " + _toDisplayString(__props.formatShortDate(equipo.fecha)), 1)
                ])
              ], 8, _hoisted_5))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})